// @packages
import React from 'react';

// @scripts
import NotFoundPage from './index';
import { config } from '../../config';

const NotFoundPageContainer = () => <NotFoundPage content={config.text.notFoundPage.content} />;

export default NotFoundPageContainer;
